import * as React from "react";
function SvgPercent(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <circle
        cx={16}
        cy={16}
        r={15}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <circle
        cx={11}
        cy={11}
        r={2}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <circle
        cx={21}
        cy={21}
        r={2}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M9 23L23 9"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgPercent);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
